export function sortQuarters(periods) {
  const quarterKey = (period) => {
    const year = Number(period.year);
    const quarter = Number(period.quarter);
    if (Number.isInteger(year) && year > 0 && Number.isInteger(quarter) && quarter >= 1 && quarter <= 4) {
      return year * 4 + quarter;
    }
    const match = period.name?.match(/^(\d{4}) Q([1-4])$/);
    return match ? Number(match[1]) * 4 + Number(match[2]) : null;
  };

  return periods.map((period, index) => ({ period, index, key: quarterKey(period) }))
    .sort((a, b) => {
      if (a.key == null) return b.key == null ? a.index - b.index : 1;
      if (b.key == null) return -1;
      return b.key - a.key || a.index - b.index;
    })
    .map(({ period }) => period);
}
